import React, { useCallback } from 'react';

import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import IconStatus from 'components/generic/IconStatus.component';
import useTip from 'hooks/useTip.hook';
import { useTranslation } from 'providers/GILT.provider';
import { useSalonNeedsReload } from 'providers/Pusher.provider';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import { locationReload } from 'utils/dom/location.util';
import call from 'utils/functions/call.util';
import logger from 'utils/logger.util';
import { concatTag as ct } from 'utils/strings/manipulate.util';

import CN from './PageReloadAlertModal.module.scss';

const L = logger('PageReloadAlertModal'); // eslint-disable-line no-unused-vars

const USE_CLOSE_BUTTON = false;

const PageReloadAlertModal = ({ tag, dismissable, onDismiss }) => {
  const { t } = useTranslation();

  const isPageInNeedOfReload = useSalonNeedsReload();
  const { inv: isNotDismissed, yay: dismiss } = useTip(false);

  const handleOk = useCallback(() => void locationReload({ tag: ct('PageReloadWatcher', 'handleOk()', tag) }), [tag]);

  const handleDismiss = useCallback(() => {
    L.info('()', 'User dismissed the dialog box');
    dismiss();
    call('PageReloadAlertModal() > onDismiss()', onDismiss);
  }, [dismiss, onDismiss]);

  return (
    <SalonModal data-tag={ct('PageReloadAlertModal', tag)} isOpen={isPageInNeedOfReload && isNotDismissed} withFooter>
      <SalonModal.Header>
        {USE_CLOSE_BUTTON && (
          <div className={CN.closeButtonContainer}>
            {fromAnyToBool(dismissable) && (
              <Button variant="empty" onClick={handleDismiss}>
                <Icon variant="close" variantInvert />
              </Button>
            )}
          </div>
        )}
      </SalonModal.Header>
      <SalonModal.Body>
        <IconStatus variant="alert" width="lg">
          <Icon variant="alert" width="l1" />
        </IconStatus>
        <div data-bem="PageReloadWatcher__content" className={CN.modalContent}>
          <div className={CN.modalTitle}>{t('pageReloadModal.title')}</div>
          <div className={CN.modalText}>{t('pageReloadModal.description')}</div>
        </div>
      </SalonModal.Body>
      <SalonModal.Footer>
        <div className={CN.modalButtons}>
          {fromAnyToBool(dismissable) && (
            <Button tag="PageReloadWatcher__reload" onClick={handleDismiss} casing="dialog" xSpace>
              {t('pageReloadModal.laterButton')}
            </Button>
          )}
          <Button tag="PageReloadWatcher__reload" onClick={handleOk} variant="primary" casing="dialog" xSpace>
            {t('pageReloadModal.reloadButton')}
          </Button>
        </div>
      </SalonModal.Footer>
    </SalonModal>
  );
};

export default PageReloadAlertModal;
